<template>
  <div class="developer-iaa-page">
    <div class="page-toolbar">
      <div>
        <h2>TikTok Developer IAA 数据</h2>
        <div class="meta-line">
          <el-tag size="mini" type="info" effect="plain">游戏日报</el-tag>
          <span>保存 Developer 后台与投放后台的日期维度数据</span>
        </div>
      </div>
      <div>
        <el-button type="primary" icon="el-icon-search" :loading="loading" @click="loadRecords">查询</el-button>
      </div>
    </div>

    <el-card shadow="never" class="filter-card">
      <el-form :model="queryForm" inline size="small">
        <el-form-item label="游戏ID">
          <el-input v-model.trim="queryForm.gameId" placeholder="如 7630750266463307797" style="width: 220px" />
        </el-form-item>
        <el-form-item label="游戏名">
          <el-input v-model.trim="queryForm.gameName" placeholder="游戏名称" style="width: 180px" />
        </el-form-item>
        <el-form-item label="地区">
          <el-input v-model.trim="queryForm.region" placeholder="US / ALL" style="width: 100px" />
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="queryForm.dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 240px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="loadRecords">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
          <el-button type="success" icon="el-icon-upload2" @click="importDialogVisible = true">导入图2数据</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-table
      :data="tableData"
      border
      stripe
      size="mini"
      v-loading="loading"
      @sort-change="handleSortChange"
      :header-cell-style="{ background: '#f8fafc', color: '#303133', fontWeight: 600 }"
    >
      <el-table-column prop="statDate" label="日期" width="110" />
      <el-table-column prop="gameName" label="游戏" min-width="150" show-overflow-tooltip />
      <el-table-column prop="gameId" label="游戏ID" width="170" show-overflow-tooltip />
      <el-table-column prop="region" label="地区" width="80" />
      <el-table-column prop="officialAdRevenue" label="官方广告收入" width="130" align="right" sortable="custom" :sort-orders="sortOrders">
        <template slot-scope="{ row }">${{ formatMoney(row.officialAdRevenue) }}</template>
      </el-table-column>
      <el-table-column prop="spend" label="消耗" width="110" align="right" sortable="custom" :sort-orders="sortOrders">
        <template slot-scope="{ row }">${{ formatMoney(row.spend) }}</template>
      </el-table-column>
      <el-table-column prop="realizedAmount" label="变现金额" width="120" align="right">
        <template slot-scope="{ row }">${{ formatMoney(row.realizedAmount) }}</template>
      </el-table-column>
      <el-table-column prop="adRevenue" label="投放广告收入" width="130" align="right" sortable="custom" :sort-orders="sortOrders">
        <template slot-scope="{ row }">${{ formatMoney(row.adRevenue) }}</template>
      </el-table-column>
      <el-table-column prop="roasDay0" label="第0天ROAS" width="110" align="right">
        <template slot-scope="{ row }">{{ formatNumber(row.roasDay0) }}</template>
      </el-table-column>
      <el-table-column prop="revenueDay0" label="第0天金额" width="120" align="right">
        <template slot-scope="{ row }">${{ formatMoney(row.revenueDay0) }}</template>
      </el-table-column>
      <el-table-column prop="roasDay3" label="3日ROAS" width="100" align="right">
        <template slot-scope="{ row }">{{ formatNumber(row.roasDay3) }}</template>
      </el-table-column>
      <el-table-column prop="revenueDay3" label="3日金额" width="110" align="right">
        <template slot-scope="{ row }">${{ formatMoney(row.revenueDay3) }}</template>
      </el-table-column>
      <el-table-column prop="roasDay7" label="7日ROAS" width="100" align="right">
        <template slot-scope="{ row }">{{ formatNumber(row.roasDay7) }}</template>
      </el-table-column>
      <el-table-column prop="revenueDay7" label="7日金额" width="110" align="right">
        <template slot-scope="{ row }">${{ formatMoney(row.revenueDay7) }}</template>
      </el-table-column>
      <el-table-column prop="roasDay14" label="14日ROAS" width="110" align="right">
        <template slot-scope="{ row }">{{ formatNumber(row.roasDay14) }}</template>
      </el-table-column>
      <el-table-column prop="revenueDay14" label="14日金额" width="120" align="right">
        <template slot-scope="{ row }">${{ formatMoney(row.revenueDay14) }}</template>
      </el-table-column>
    </el-table>

    <div class="pagination-row">
      <span>共 {{ pagination.total }} 条</span>
      <el-pagination
        background
        layout="sizes, prev, pager, next, jumper"
        :current-page="pagination.page"
        :page-size="pagination.pageSize"
        :page-sizes="[20, 50, 100, 200]"
        :total="pagination.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      title="导入图2数据"
      :visible.sync="importDialogVisible"
      width="860px"
      :close-on-click-modal="false"
    >
      <el-form :model="importForm" label-width="86px" size="small">
        <el-row :gutter="12">
          <el-col :span="10">
            <el-form-item label="游戏ID">
              <el-input v-model.trim="importForm.gameId" placeholder="必填" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="游戏名">
              <el-input v-model.trim="importForm.gameName" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="地区">
              <el-input v-model.trim="importForm.region" placeholder="US" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="表格数据">
          <el-input
            v-model="importForm.rawText"
            type="textarea"
            :rows="12"
            placeholder="从网页或 Excel 复制图2表格数据到这里。顺序：日期、官方广告收入、消耗、变现金额、投放广告收入、第0天ROAS、第0天金额、3日ROAS、3日金额、7日ROAS、7日金额、14日ROAS、14日金额"
          />
        </el-form-item>
        <el-form-item>
          <el-tag size="mini" type="info">已识别 {{ parsedRecords.length }} 行</el-tag>
          <span class="hint">会按游戏ID、日期、地区覆盖更新同一天数据。</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="importDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="importing" @click="saveImport">保存到数据库</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { importDeveloperIaaDailyRecords, queryDeveloperIaaDailyRecords } from '@/api/tiktokDeveloperIaa'

export default {
  name: 'DeveloperIaaData',
  data() {
    return {
      loading: false,
      importing: false,
      importDialogVisible: false,
      queryForm: {
        gameId: '',
        gameName: '',
        region: '',
        dateRange: []
      },
      importForm: {
        gameId: '7630750266463307797',
        gameName: 'Rush Warriors',
        region: 'US',
        rawText: ''
      },
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      sortOrders: ['descending', 'ascending', null],
      sortState: {
        field: '',
        order: ''
      }
    }
  },
  computed: {
    parsedRecords() {
      return this.parseImportText(this.importForm.rawText)
    }
  },
  mounted() {
    this.loadRecords()
  },
  methods: {
    async loadRecords() {
      this.loading = true
      try {
        const range = this.queryForm.dateRange || []
        const response = await queryDeveloperIaaDailyRecords({
          gameId: this.queryForm.gameId,
          gameName: this.queryForm.gameName,
          region: this.queryForm.region,
          startDate: range[0],
          endDate: range[1],
          sortField: this.sortState.field,
          sortOrder: this.sortState.order,
          page: this.pagination.page - 1,
          size: this.pagination.pageSize
        })
        const pageData = response.data || {}
        this.tableData = pageData.content || []
        this.pagination.total = Number(pageData.totalElements || 0)
      } catch (e) {
        this.$message.error(e.message || '查询失败')
      } finally {
        this.loading = false
      }
    },
    async saveImport() {
      if (!this.importForm.gameId) {
        this.$message.warning('请填写游戏ID')
        return
      }
      if (this.parsedRecords.length === 0) {
        this.$message.warning('没有识别到可保存的数据行')
        return
      }
      this.importing = true
      try {
        const response = await importDeveloperIaaDailyRecords({
          gameId: this.importForm.gameId,
          gameName: this.importForm.gameName,
          region: this.importForm.region || 'ALL',
          source: 'developer_portal_paste',
          importedBy: this.currentUsername(),
          records: this.parsedRecords
        })
        const result = response.data || {}
        this.$message.success(`保存完成：新增 ${result.inserted || 0} 条，更新 ${result.updated || 0} 条`)
        this.importDialogVisible = false
        this.queryForm.gameId = this.importForm.gameId
        this.queryForm.gameName = this.importForm.gameName
        this.queryForm.region = this.importForm.region
        this.pagination.page = 1
        await this.loadRecords()
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      } finally {
        this.importing = false
      }
    },
    parseImportText(text) {
      const lines = String(text || '').split(/\r?\n/).map(line => line.trim()).filter(Boolean)
      const records = []
      lines.forEach(line => {
        const cells = this.splitLine(line)
        if (cells.length < 2 || !this.isDate(cells[0])) {
          return
        }
        records.push({
          statDate: this.normalizeDate(cells[0]),
          officialAdRevenue: this.money(cells[1]),
          spend: this.money(cells[2]),
          realizedAmount: this.money(cells[3]),
          adRevenue: this.money(cells[4]),
          roasDay0: this.number(cells[5]),
          revenueDay0: this.money(cells[6]),
          roasDay3: this.number(cells[7]),
          revenueDay3: this.money(cells[8]),
          roasDay7: this.number(cells[9]),
          revenueDay7: this.money(cells[10]),
          roasDay14: this.number(cells[11]),
          revenueDay14: this.money(cells[12]),
          rawPayload: { line }
        })
      })
      return records
    },
    splitLine(line) {
      if (line.indexOf('\t') >= 0) {
        return line.split('\t').map(item => item.trim())
      }
      return line.split(',').map(item => item.trim())
    },
    isDate(value) {
      return /^\d{4}[-/]\d{1,2}[-/]\d{1,2}$/.test(String(value || '').trim())
    },
    normalizeDate(value) {
      const parts = String(value || '').replace(/\//g, '-').split('-')
      return `${parts[0]}-${String(parts[1]).padStart(2, '0')}-${String(parts[2]).padStart(2, '0')}`
    },
    money(value) {
      return this.number(value)
    },
    number(value) {
      const text = String(value === undefined || value === null ? '' : value)
        .replace(/[$,%]/g, '')
        .replace(/,/g, '')
        .trim()
      if (!text || text === '-') {
        return 0
      }
      const number = Number(text)
      return Number.isFinite(number) ? number : 0
    },
    formatMoney(value) {
      return this.number(value).toFixed(2)
    },
    formatNumber(value) {
      const number = this.number(value)
      return Number.isInteger(number) ? String(number) : number.toFixed(4).replace(/0+$/, '').replace(/\.$/, '')
    },
    currentUsername() {
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}')
        return user.username || ''
      } catch (e) {
        return ''
      }
    },
    resetQuery() {
      this.queryForm = {
        gameId: '',
        gameName: '',
        region: '',
        dateRange: []
      }
      this.sortState = {
        field: '',
        order: ''
      }
      this.pagination.page = 1
      this.loadRecords()
    },
    handleSortChange({ prop, order }) {
      this.sortState = {
        field: prop || '',
        order: order || ''
      }
      this.pagination.page = 1
      this.loadRecords()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.loadRecords()
    },
    handleCurrentChange(page) {
      this.pagination.page = page
      this.loadRecords()
    }
  }
}
</script>

<style scoped>
.developer-iaa-page {
  padding: 16px;
  background: #f5f7fb;
  min-height: 100%;
}

.page-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.page-toolbar h2 {
  margin: 0 0 6px;
  font-size: 20px;
  color: #1f2937;
}

.meta-line {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6b7280;
  font-size: 12px;
}

.filter-card {
  margin-bottom: 12px;
  border-radius: 6px;
}

.pagination-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  color: #606266;
  font-size: 13px;
}

.hint {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
}
</style>
